import React, { useMemo } from 'react';

import { LocationDTO, OrganizationDTO } from '@/api/generated.ts';
import { useOrganizationStructure } from '@/hooks/useOrganizationStructure.tsx';

import LocationDisplay, { LocationDisplayProps } from './LocationDisplay.tsx';

interface CachedLocationDisplayProps extends LocationDisplayProps {
  organizationSlug?: string;
  locationSlug?: string;
}

const CachedLocationDisplay: React.FC<CachedLocationDisplayProps> = ({ locationSlug, organizationSlug, ...props }) => {
  const { mapStructure } = useOrganizationStructure();
  const location: LocationDTO | undefined = locationSlug ? mapStructure?.[locationSlug] : undefined;
  const organization: OrganizationDTO | undefined = organizationSlug ? mapStructure?.[organizationSlug] : undefined;

  const displayProps = useMemo(
    () => ({
      ...props,
      location,
      organization
    }),
    [location, organization, props]
  );

  return <LocationDisplay {...displayProps} />;
};

export default CachedLocationDisplay;
